exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RenderWindowWithControlBar-module-rootContainer_1lck8 {\n  position: relative;\n}\n\n.RenderWindowWithControlBar-module-renderWindow_FOOWk {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.RenderWindowWithControlBar-module-control_1muSX {\n  z-index: 1;\n  position: absolute;\n}\n", ""]);

// exports
exports.locals = {
	"rootContainer": "RenderWindowWithControlBar-module-rootContainer_1lck8",
	"renderWindow": "RenderWindowWithControlBar-module-renderWindow_FOOWk",
	"control": "RenderWindowWithControlBar-module-control_1muSX"
};